import { FC } from "react";
import { useTranslation } from "react-i18next";
import SaleTabPane, { TabProps } from "@/components/TabPane";
import { InspectionOrder } from "@/types/inspection";
import InspectionList from "./components/InspectionList";

type CustomerTabType = 'doc'

const InspectionHome: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "list"
  const TAB_KEY = "doc"

  const keyObj: (info: InspectionOrder) => { [key in CustomerTabType]: TabProps } = (info) => ({
    doc: {
      key: TAB_KEY,
      label: (info.number),
      children: <></>
    },
  })


  return <SaleTabPane<InspectionOrder> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("inspection.inspection"),
      children: <InspectionList />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default InspectionHome;